import type { VaLanguage } from './Common'

export type CallStatus =
  | 'confusion'
  | 'too_long'
  | 'hostility'
  | 'unsatisfaction'
  | 'complaint'
  | 'vulgarity'
  | 'fraud'
  | 'OK'

export const AgentStatus = {
  Stable: 'stable',
  Warning: 'warning',
} as const

export const CallStatusSeverity = {
  OK: 0,
  confusion: 1,
  too_long: 1,
  unsatisfaction: 1,
  complaint: 1,
  hostility: 1,
  vulgarity: 1,
  fraud: 1,
} as const

export type CallStatusSeverity = typeof CallStatusSeverity

export type AgentStatus = (typeof AgentStatus)[keyof typeof AgentStatus]

export interface ActiveCall {
  id: string
  callerNumber: string
  roomName: string
  startTime: number
  endTime?: number
  durationSec?: number
  language: VaLanguage
  status: CallStatus[]
}

export interface VirtualAgentSummary {
  id: string
  name: string
  uptimeStartedAt: number
  activeCallsCount: number
  problematicCallsCount?: number
  languages: VaLanguage[]
  activeCalls: ActiveCall[]
  agentStatus?: AgentStatus
}

export interface VaSnapshotPayload {
  at: number
  virtualAgents: VirtualAgentSummary[]
}

export interface VaFilters {
  languages?: VaLanguage[]
  statuses?: CallStatus[]
  agents?: string[]
  agentsStatuses?: AgentStatus[]
}
